<template>
  <div>
    <nav class="tabs mb-lg" :class="containerExtraClass">
      <ul
        :style="
          spaced ? 'justify-content: space-evenly' : 'justify-content: start;'
        "
      >
        <li
          v-for="(tab, i) in tabs"
          :key="i"
          class="tabs__link"
          :class="isActiveTab(tab)"
          @click="changeTab(tab)"
          style="padding: 0;"
        >
          <router-link
            :to="tab.path"
            class="theme-text-dark fs-xxs f-uppercase fw-bold"
            :class="spaced ? 'compress-tabs' : ''"
          >
            {{ tab.name }}
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'tabSelector',
  props: {
    containerExtraClass: {
      type: String,
      default: '',
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    spaced: Boolean,
  },
  data() {
    return {
      active: this.tabs[0].name,
    };
  },
  methods: {
    changeTab(tab) {
      return (this.active = tab.name);
    },
    isActiveTab(tab) {
      let currentPath = this.$route.path;
      return currentPath == tab.path ? 'is-active' : '';
      //return this.active == tab.name ? 'is-active':"";
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs__link a {
  display: flex;
  height: 50px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  padding: 0 3em;
  &.compress-tabs {
    padding: 0 2em;
  }
}

@media screen and (min-width: 737px) and (max-width: 1439px) {
  .tabs__link a.compress-tabs {
    padding: 0 1em;
  }
}

@media screen and (min-width: 737px) and (max-width: 820px) {
  .tabs__link a.compress-tabs {
    padding: 0;
  }
}
</style>
